import { render, staticRenderFns } from "./confirmarestudiantes.vue?vue&type=template&id=270255c2"
import script from "./confirmarestudiantes.vue?vue&type=script&lang=js"
export * from "./confirmarestudiantes.vue?vue&type=script&lang=js"
import style0 from "./confirmarestudiantes.vue?vue&type=style&index=0&id=270255c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports